import { render } from "./PrintFooter8cm.vue?vue&type=template&id=93bff376&scoped=true"
import script from "./PrintFooter8cm.vue?vue&type=script&lang=js"
export * from "./PrintFooter8cm.vue?vue&type=script&lang=js"

import "./PrintFooter8cm.vue?vue&type=style&index=0&id=93bff376&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93bff376"]])

export default __exports__